import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { useSelector } from "react-redux";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReactSelect from "../../../../app/modules/UI/ReactSelect";
import ReactSelectNotClear from "../../../../app/modules/UI/ReactSelectNotClear";

const initialValues = {
  dutyId: "",
  structureId: "",
  middleName: "",
  name: "",
  surname: "",
  email: "",
  password: "",
  username: "",
};

export default function Create(props) {
  const token = useSelector((state) => state.auth.token);
  const {
    show,
    onHide,
    onGroups,
    skip,
    take,
    filterInputs,
    orderBy,
    sortField,
    dutyId,
    structureId,
  } = props;
  const [isError, setIsError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const [isLoading, setIsLoading] = useState(false);
  const [dutiesOption, setDutiesOption] = React.useState(null);
  const [chooseStructureIdOption, setChooseStructureIdOption] = useState([]);

  const [department, setDepartment] = useState();
  const [directorate, setDirectorate] = useState();
  const [branch, setBranch] = useState();
  const [division, setDivision] = useState();
  const [structureType, setStructureType] = useState();

  const [chooseDepartmentOption, setChooseDepartmentOption] = useState([]);
  const [chooseDirectorateOption, setChooseDirectorateOption] = useState([]);
  const [chooseBranchOption, setChooseBranchOption] = useState([]);
  const [chooseDivisionOption, setChooseDivisionOption] = useState([]);
  const [chooseStructureTypeOption, setChooseStructureTypeOption] = useState(
    []
  );

  const CreateSchema = Yup.object().shape({
    name: Yup.string().required("Ad tələb olunur."),
    surname: Yup.string().required("Soyad tələb olunur."),
    // email: Yup.string()
    //   .email('Email formatı səhvdir. Örnək: jhon.doe@example.com'),
    // .required('Email tələb olunur.'),
    middleName: Yup.string().required("Ata adı tələb olunur."),
    username: Yup.string().required("İstifadəçi adı tələb olunur."),
    dutyId: Yup.string().required("Vəzifə tələb olunur."),
    structureId: Yup.string().required("Struktur tələb olunur."),
    password: Yup.string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_-])(?=.{8,})/,
        "Şifrə uzunluğu 8 olan böyük hərf, kiçik hərf, rəqəm və simvoldan ibarət olmalıdır."
      )
      .required("Şifrə tələb olunur."),
  });

  const getInputClasses = (filedName) => {
    if (formik.touched[filedName] && formik.errors[filedName]) {
      return true;
    }
    if (formik.touched[filedName] && !formik.errors[filedName]) {
      return false;
    }

    return false;
  };

  const onPostGroup = (values, resetForm, setSubmitting) => {
    setIsLoading(true);

    const group = {
      name: values.name,
      surname: values.surname,
      email: values.email,
      middleName: values.middleName,
      username: values.username,
      dutyId: values.dutyId,
      structureId: values.structureId,
      password: values.password,
    };
    const group1 = {
      name: values.name,
      surname: values.surname,
      middleName: values.middleName,
      username: values.username,
      dutyId: values.dutyId,
      structureId: values.structureId,
      password: values.password,
    };

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}user`,
      data: values.email ? group : group1,
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((res) => {
        onGroups(orderBy, sortField, skip, take, filterInputs);
        setSubmitting(false);
        resetForm();
        onHide(false);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);

        let message =
          typeof err.response !== "undefined"
            ? !err.response.data.checks && err.response.data.message
              ? err.response.data.message
              : (err.response.data.checks.name ||
                  err.response.data.checks.middleName ||
                  err.response.data.checks.surname) &&
                !err.response.data.checks.email
              ? "Ad , soyad və ata adı yalnız hərflərdən ibarət olmalıdır"
              : (err.response.data.checks.name ||
                  err.response.data.checks.middleName ||
                  err.response.data.checks.surname) &&
                err.response.data.checks.email
              ? "Ad , soyad və ata adı yalnız hərflərdən ibarət olmalıdır. Email formatı səhvdir. Örnək:jhon.doe@example.com "
              : !err.response.data.checks.name &&
                !err.response.data.checks.middleName &&
                !err.response.data.checks.surname &&
                err.response.data.checks.email &&
                "Email formatı səhvdir. Örnək: jhon.doe@example.com"
            : err.message;
        setIsError(message);
      });
  };

  const formik = useFormik({
    initialValues,
    validationSchema: CreateSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      onPostGroup(values, resetForm, setSubmitting);
    },
  });

  const resetForm = () => {
    onHide();
    formik.resetForm();
  };

  useEffect(() => {
    setIsError("");
  }, [show]);

  // useEffect(() => {
  //   // console.log(permissions);
  //   console.log(dutiesOption)
  // }, [dutiesOption])

  function handleChangeDuties(value) {
    setDutiesOption(value);
    formik.setFieldValue("dutyId", value.value);
  }

  function handleChangeStructure(value) {
    setChooseStructureIdOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));
        const newDirectorateItem = displayTypes.filter((obj) => {
          return obj.type === "DIRECTORATE";
        });
        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });

        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDirectorate(newDirectorateItem);

        setDepartment(newDepartmentItem);
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDirectorateOption(null);
        setChooseDepartmentOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  }

  const handleChangeDirectorateNames = (value) => {
    setChooseDirectorateOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));
        const newDepartmentItem = displayTypes.filter((obj) => {
          return obj.type === "DEPARTMENT";
        });
        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDepartment(newDepartmentItem);
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDepartmentOption(null);
        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeDepartmentNames = (value) => {
    setChooseDepartmentOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newBranchItem = displayTypes.filter((obj) => {
          return obj.type === "BRANCH";
        });
        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setBranch(newBranchItem);
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseBranchOption(null);
        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeBranchNames = (value) => {
    setChooseBranchOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newDivisionItem = displayTypes.filter((obj) => {
          return obj.type === "DIVISION";
        });
        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setDivision(newDivisionItem);
        setStructureType(newStructureTypeItem);

        setChooseDivisionOption(null);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeDivisionNames = (value) => {
    setChooseDivisionOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");

    axios
      .get(
        `${process.env.REACT_APP_API_URL}structure/select?id=${
          value ? value.value : ""
        }`
      )
      .then((res) => {
        const displayTypes = res.data.map(({ id, name, type }) => ({
          value: id,
          label: name,
          type: type,
        }));

        const newStructureTypeItem = displayTypes.filter((obj) => {
          return obj.type === "STRUCTURE_TYPE";
        });
        setStructureType(newStructureTypeItem);
        setChooseStructureTypeOption(null);
      });
  };

  const handleChangeStructureTypeNames = (value) => {
    setChooseStructureTypeOption(value);
    formik.setFieldValue("structureId", value ? value.value : "");
  };

  return (
    <Modal
      size="xl"
      aria-labelledby="create"
      centered
      className="modal pr-0"
      show={show}
      onHide={resetForm}
    >
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title id="create">Əlavə et</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />

                  <ReactSelect
                    suggestions={structureId}
                    handleChangeSingle={(value) => handleChangeStructure(value)}
                    single={chooseStructureIdOption}
                    label="Şirkət  seçin"
                    placeholder="Şirkət seçin"
                    inputId="structureId"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />

                  <ReactSelect
                    suggestions={directorate}
                    handleChangeSingle={(value) =>
                      handleChangeDirectorateNames(value)
                    }
                    single={chooseDirectorateOption}
                    label="Direktorluq  seçin"
                    placeholder="Direktorluq seçin"
                    inputId="Directorate"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />

                  <ReactSelect
                    suggestions={department}
                    handleChangeSingle={(value) =>
                      handleChangeDepartmentNames(value)
                    }
                    single={chooseDepartmentOption}
                    label="Departament  seçin"
                    placeholder="Departament seçin"
                    inputId="department"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />
                  <ReactSelect
                    suggestions={branch}
                    handleChangeSingle={(value) =>
                      handleChangeBranchNames(value)
                    }
                    single={chooseBranchOption}
                    label="Şöbə  seçin"
                    placeholder="Şöbə seçin"
                    inputId="branch"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />
                  <ReactSelect
                    suggestions={division}
                    handleChangeSingle={(value) =>
                      handleChangeDivisionNames(value)
                    }
                    single={chooseDivisionOption}
                    label="Bölmə seçin"
                    placeholder="Bölmə seçin"
                    inputId="division"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="structureId"
                    hidden
                    {...formik.getFieldProps("structureId")}
                  />
                  <ReactSelect
                    suggestions={structureType}
                    handleChangeSingle={(value) =>
                      handleChangeStructureTypeNames(value)
                    }
                    single={chooseStructureTypeOption}
                    label="Struktur növü  seçin"
                    placeholder="Struktur növü seçin"
                    inputId="Struktur növü"
                  />
                </div>
                {formik.touched.structureId && formik.errors.structureId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.structureId}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <input
                    type="text"
                    name="dutyId"
                    hidden
                    {...formik.getFieldProps("dutyId")}
                  />

                  <ReactSelectNotClear
                    suggestions={dutyId}
                    handleChangeSingle={handleChangeDuties}
                    single={dutiesOption}
                    label="Vəzifə seçin"
                    placeholder="Vəzifə seçin"
                    inputId="dutyId"
                  />
                </div>
                {formik.touched.dutyId && formik.errors.dutyId ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.dutyId}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="name"
                    name="name"
                    label="Ad"
                    placeholder="Ad"
                    className="w-100"
                    error={getInputClasses("name")}
                    {...formik.getFieldProps("name")}
                  />
                </div>
                {formik.touched.name && formik.errors.name ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.name}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="surname"
                    name="surname"
                    label="Soyad"
                    placeholder="Soyad"
                    className="w-100"
                    error={getInputClasses("surname")}
                    {...formik.getFieldProps("surname")}
                  />
                </div>
                {formik.touched.surname && formik.errors.surname ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.surname}</div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="middleName"
                    name="middleName"
                    label="Ata adı"
                    placeholder="Ata adı"
                    className="w-100"
                    error={getInputClasses("middleName")}
                    {...formik.getFieldProps("middleName")}
                  />
                </div>
                {formik.touched.middleName && formik.errors.middleName ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.middleName}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="email"
                    name="email"
                    label="Email adres"
                    placeholder="Email adres"
                    className="w-100"
                    error={getInputClasses("email")}
                    {...formik.getFieldProps("email")}
                  />
                </div>
                {formik.touched.email && formik.errors.email ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.email}</div>
                  </div>
                ) : null}
              </div>

              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="username"
                    name="username"
                    label="İstifadəçi adı"
                    placeholder="İstifadəçi adı"
                    className="w-100"
                    error={getInputClasses("username")}
                    {...formik.getFieldProps("username")}
                  />
                </div>
                {formik.touched.username && formik.errors.username ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.username}
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="col-6 col-md-6 col-lg-6">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    label="Şifrə"
                    placeholder="Şifrə"
                    className="w-100"
                    error={getInputClasses("password")}
                    {...formik.getFieldProps("password")}
                    InputProps={{
                      // <-- This is where the toggle button is added.
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                {formik.touched.password && formik.errors.password ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                      {formik.errors.password}
                    </div>
                  </div>
                ) : null}
              </div>

              {isError && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block MuiFormLabel-root Mui-error">
                    {isError}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => {
              onHide(false);
              formik.resetForm();
            }}
          >
            Ləğv et
          </Button>
          <Button type="submit" className={isLoading ? "px-9" : ""}>
            <span>Əlavə et</span>
            {isLoading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
